const LABELS = {
  save_the_date: 'Save The Date',
  preinvitation: 'Preinvitacion',
  event_reminder: 'Recordatorio de Evento',
  invitation: 'Enviar Invitaciones',
  reminder: 'Enviar Recordatorios',
  remember: 'Enviar Recordatorios',
  message: 'Enviar Mensaje',
  table: 'Enviar Mesa',
  tickets: 'Enviar Tickets'
}

export default function useMessageTypeLabel() {
  function getMessageTypeLabel(type) {
    const key = (type || '').toString().trim()
    return LABELS[key] || key || '-'
  }

  return {
    getMessageTypeLabel
  }
}
